__turbopack_context__.v({
  "app-info": "index-module-scss-module__JthAzq__app-info",
  "app-name": "index-module-scss-module__JthAzq__app-name",
  "dist-name": "index-module-scss-module__JthAzq__dist-name",
  "download-app-bar": "index-module-scss-module__JthAzq__download-app-bar",
  "logo": "index-module-scss-module__JthAzq__logo",
  "text": "index-module-scss-module__JthAzq__text",
});
